import React from 'react';
import styles from './BottomNav.module.css';

function BottomNav({
  visible = true,
  menuItems = [],
  activeKey,
  onMenuClick
}) {
  if (!visible) return null;

  return (
    <div className={styles.bottomNav}>
      {menuItems.map(item => (
        <div
          key={item.key}
          className={`${styles.bottomNavItem} ${activeKey === item.key ? styles.active : ''}`}
          onClick={() => onMenuClick?.(item)}
        >
          <span className={styles.bottomNavIcon}>
            {item.icon?.startsWith('#') ? (
              <svg className={styles.bottomNavSvgIcon} aria-hidden="true">
                <use xlinkHref={item.icon}></use>
              </svg>
            ) : (
              item.icon || '•'
            )}
          </span>
          <div className={styles.bottomNavLabel}>{item.label}</div>
        </div>
      ))}
    </div>
  );
}

export default BottomNav;